var $b09fec806b7b8f22$exports = {};
$b09fec806b7b8f22$exports = {
  "pending": "\u043D\u0435\u0434\u043E\u0432\u044A\u0440\u0448\u0435\u043D\u043E"
};
export { $b09fec806b7b8f22$exports as default };